import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-57f5fba7"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "icon-container p-d-flex p-jc-center p-ai-center",
  id: "icon__upload"
}
const _hoisted_2 = {
  for: "dropZoneFile",
  class: "text-secondary p1 medium"
}
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "dropzone-active-overlay" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "dropzone-background" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_close = _resolveComponent("close")!
  const _component_cloud_arrow_up = _resolveComponent("cloud-arrow-up")!
  const _component_icon = _resolveComponent("icon")!
  const _component_file_tag = _resolveComponent("file-tag")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["drop-zone p-d-flex p-flex-column p-ai-center bg-dark-gray drop-zone__border", [_ctx.error ? 'drop-zone__border--error' : '', _ctx.isDisabled ? 'drop-zone__border--disabled' : '']]),
    onDrop: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleOnDrop && _ctx.handleOnDrop(...args)), ["prevent"])),
    onDragover: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
    id: "dropzone-container"
  }, [
    _createElementVNode("span", _hoisted_1, [
      _createVNode(_component_icon, {
        size: _ctx.error ? 24 : 44,
        viewBox: _ctx.error ? '0 0 24 24' : '0 0 44 44',
        strokeColor: _ctx.error ? 'var(--error)' : _ctx.isDisabled ? 'var(--light-gray)' : 'var(--secondary)'
      }, {
        default: _withCtx(() => [
          (_ctx.error)
            ? (_openBlock(), _createBlock(_component_close, { key: 0 }))
            : (_openBlock(), _createBlock(_component_cloud_arrow_up, { key: 1 }))
        ]),
        _: 1
      }, 8, ["size", "viewBox", "strokeColor"])
    ]),
    (!_ctx.isFileSelected)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("p", {
            class: _normalizeClass(["p2 text-white", _ctx.isDisabled ? 'disabled-input' : ''])
          }, [
            _createTextVNode(_toDisplayString(_ctx.heading1) + " ", 1),
            _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.copies.InputFile.label), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.copies.InputFile.heading2), 1)
          ], 2),
          _createElementVNode("p", {
            innerHTML: _ctx.infoText,
            class: "p3 text-white p-text-center"
          }, null, 8, _hoisted_3),
          _createElementVNode("input", {
            type: "file",
            name: "inputFile",
            id: "dropZoneFile",
            accept: ".jpg, .jpeg, .png, .pdf, .gzip, .doc, .rar, .zip",
            onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleOnChange && _ctx.handleOnChange(...args))),
            class: _normalizeClass(_ctx.isDisabled ? 'disabled-input' : ''),
            disabled: _ctx.isDisabled
          }, null, 42, _hoisted_4)
        ], 64))
      : (_openBlock(), _createBlock(_component_file_tag, {
          key: 1,
          class: "file-tag animation__file",
          onOnDelete: _ctx.handleDeleteFile,
          isUpload: "",
          data: _ctx.fileData
        }, null, 8, ["onOnDelete", "data"])),
    _hoisted_5,
    _hoisted_6
  ], 34))
}